import { ForbiddenError, Resource, Route } from '@resourceful-hono/core';
import { User } from '../../entities/User.ts';
import { settle } from '@monocle-money/utils';

@Route('/api/v1/')
export class BaseResource extends Resource {
  declare public userId?: number;

  protected get user() {
    if (!this.userId) throw new ForbiddenError(); 
    return settle(
      User.findOne({
        where: { id: this.userId },
        relations: { game: true },
      })
    )
      .then(result => {
        if (result.status === 'fulfilled' && result.value)
          return result.value;
        throw new ForbiddenError();
      });
  }
}